intra_module.directive('flexinput', function() {
	return {
		restrict:    'E',
		templateUrl: 'directives/flexinput/template.html',
		replace:     true,
		transclude:  true,

		scope: {
			model:         '=ngModel',
			placeholder:   '@',
			submit:        '&submit',
			disabledState: '&'
		},

		link(scope, element, attr) {
			scope.text =
				'Demande de validation...' === scope.placeholder ? 'Faire la demande de validation' : 'Envoyer';

			scope.validator = () => (scope.model != null) && ('' !== scope.model.trim());

			scope.check = function() {
				if (!scope.validator()) { return; }
				scope.submit();
			};
		}
	};
});
